var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedExclamation = function SvgRedExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E11B22",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E11B22",
    d: "M12 13.68a1.2 1.2 0 0 0 1.2-1.2V6.888a1.2 1.2 0 1 0-2.4 0v5.592a1.2 1.2 0 0 0 1.2 1.2M12 18.312a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgRedExclamation;